import Vue from 'vue'
import Router from 'vue-router'
import store from '@/plugins/store/index.js'
import { loadTranslation } from '@/plugins/i18n/index.js'

import mainRoutes from './routes/mainRoutes.js'
import adminRoutes from './routes/adminRoutes.js'
import processes from './routes/processes.js'
import tasks from './routes/tasks.js'
import survey from './routes/survey.js'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	routes: [
		...processes,
		...tasks,
		...survey,
		...adminRoutes,
		...mainRoutes,
	],
	// Add this scrollBehavior function
	scrollBehavior(to, from, savedPosition) {
		// If there's a saved position (browser back/forward), use it
		if (savedPosition) {
			return savedPosition
		}
		// If there's a hash anchor in the URL, scroll to it
		if (to.hash) {
			return {
				selector: to.hash,
				behavior: 'smooth'
			}
		}
		// Otherwise, scroll to top
		return { x: 0, y: 0 }
	}
})

router.beforeEach((to, from, next) => {

	store.dispatch('app/translationFailed', false)
	loadTranslation()
		.then(() => {
			//if user is authenticated and	 tries to access login
			if (to.name == 'login' && store.getters['user/isAuthenticated']) {
				next({ name: 'home' })
			}
			else {

				//check if page is for authenticated users only
				if (to.meta && to.meta.secure && !store.getters['user/isAuthenticated']) {
					next({ name: 'landing' })
				}
				else {
					//this is for pages that doesnt require authentication
					next()
				}
			}

		})
		.catch(() => {
			console.log('failed to load translations')
			store.dispatch('app/translationFailed', true)
		})
})

export default router